<template>
  <div class="orderForm">
    <div class="mask"></div>
    <div class="main">
      <ul>
        <li><h2><span class="xin">*</span>联 系 人：</h2><input v-model="username" type="text"/></li>
        <li><h2><span class="xin">*</span>联系方式：</h2><input v-model="tel" type="text"/></li>
        <li><h2><span class="xin">*</span>办理地点：</h2><input v-model="address" type="text"/></li>
        <li><h2><span class="xin">*</span>预约人数：</h2><input v-model="count" type="text"/></li>
        <li>
          <button @click="saveAction">保存</button>
          <button @click="cancelAction">取消</button>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
  import {deepClone} from 'common/js/deepClone'
  //公共数据
  import {mapState, mapGetters, mapMutations} from 'vuex';

  export default {
    name: "orderForm",
    data() {
      return {
        username: null,
        tel: null,
        address: null,
        count: null
      }
    },
    props: {
      payload: {
        type: Object
      }
    },
    computed: {
      ...mapState(['userInfo']),
    },
    methods: {
      saveAction() {

        if(!(this.username && this.tel && this.address && this.count)){
          this.$notify({
            group:'global',
            title:'温馨提示',
            text:'联系人、联系方式、办理地点、预约人数为必填项，请确认填写完整！'
          })
          return
        }

        let payload=deepClone(this.payload)
        this.$emit('saveAction', {
          payload: payload,
          username: this.username,
          tel: this.tel,
          address: this.address,
          count: this.count
        })
      },
      cancelAction() {
        this.$emit('cancel')
      }
    },
    components: {},
    mounted() {
      this.username = this.payload.username
      if(!this.username){
        this.username=this.userInfo.username
      }
      this.tel = this.payload.tel
      if(!this.tel){
        this.tel=this.userInfo.tel
      }
      this.address = this.payload.address
      this.count = this.payload.count
    }
  }
</script>

<style lang="stylus" scoped>
  @import "~common/stylus/config.styl"
  .orderForm
    .mask
      position absolute
      left 0
      right 0
      top 0
      bottom 0
      background rgba(0, 0, 0, 0.5)
      width 100%
      height 100%

    .main
      overflow-y scroll
      padding 20px
      color #666666
      font-size 14px
      box-shadow 3px 3px 3px #666
      position absolute
      left 0
      right 0
      top 0
      bottom 0
      margin auto
      width 800px
      height 300px
      background #f1f1f1

      & > ul
        li
          text-align center
          padding-left 60px
          margin 20px

          & > button
            width 100px
            height 26px
            border-radius 13px
            border 1px solid #cccccc
            background-color #ffffff
            outline none
            transition 300ms
            margin-top 20px
            margin-right 20px

            &:hover
              background-color #eeeeee

          & > input
            width 260px
            height 24px
            border-radius 13px
            border 1px solid #cccccc
            padding 0 10px
            font-size 14px
            color #666666

          h2
            display inline-block

            .xin
              font-weight bold
              color #f00
              margin-right 5px
</style>


// WEBPACK FOOTER //
// src/components/order/orderForm.vue